import {disableIframeHiddenInputs} from "../../modals/iframe-modal/iframe-modal"
import {openModal} from "../../modal/modal"

const radioBoxFields = document.querySelectorAll<HTMLElement>(".f-radio-box")

radioBoxFields.forEach((radioBox) => {
  const input = radioBox.querySelector<HTMLInputElement>(".f-radio-box__input")
  const options = radioBox.querySelector<HTMLSelectElement>(".f-radio-box__options select")
  const preventPayment = radioBox.querySelector<HTMLElement>(".m-prevent-payment")
  const balikovnaModal = radioBox.querySelector<HTMLElement>(".m-balikovna")
  const preventPaymentConfirm = preventPayment?.querySelector(".m-prevent-payment__confirm")

  if (!input) return

  radioBox.addEventListener("click", () => {
    if (input.checked) input.checked = !radioBox.classList.contains("--checkbox")
    else input.checked = !(radioBox.classList.contains("--with-parcel") || radioBox.classList.contains("--prevent-payment") || radioBox.classList.contains("--balikovna"))

    if (preventPayment) {
      openModal(preventPayment)
    }

    if (balikovnaModal) {
      const balikovnaParcel = radioBox.querySelector<HTMLElement>(".i-balikovna-parcel")

      if (balikovnaParcel?.classList.contains("d-none")) openModal(balikovnaModal)
    }

    input.dispatchEvent(new Event("change"))
  })

  input?.addEventListener("change", () => {
    radioBoxFields.forEach((radioBox) => {
      radioBox.dispatchEvent(new Event("deselect"))
      const hiddenInput = radioBox.querySelector<HTMLInputElement>('input[type="hidden"]')
      if (radioBox.querySelector<HTMLInputElement>('input[type="radio"]:checked') && hiddenInput) hiddenInput.disabled = false
    })

    if (!options) return
    options.disabled = !input.checked
  })

  radioBox.addEventListener("deselect", () => {
    disableIframeHiddenInputs()
    if (!options) return
    options.disabled = true
  })

  preventPaymentConfirm?.addEventListener("click", () => {
    if (input) input.checked = true
    input.dispatchEvent(new Event("change"))
  })

  if (!options) return
  options.disabled = !input.checked
})
